import { gql } from "apollo-boost";

export const DAILY_CLOSING_GET_ALL = gql`
  query getDailyClosingSummary($where: DailyClosingSummaryWhereInput!) {
    getDailyClosingSummary(where: $where) {
      byArs {
        arsId
        arsName
        contrated
        coverage
        quantityOfServices
        validation
      }
      byPaymentMethod {
        paymentMethodId
        paymentMethodName
        copagoArs
        diferencia
        copago
        fee
        quantityOfServices
        validation
      }
      dateExcludes {
        date
      }
    }
  }
`;

export const SAVE_DATE_CUT_IN_SALES = gql`
  mutation saveDateCutInSales($data: saveDateCutInput) {
    saveDateCutInSales(data: $data)
  }
`;
